import { USER_DATA_TYPE } from '@monofront/business/constants';
import logger from '@utils/logger';
import { Banner } from './Banner';
import { ImageBanner } from './ImageBanner';
import { useQueryRules } from 'react-instantsearch-core';

export const Banners = () => {
  const { items } = useQueryRules();

  const banners = items.filter((item) =>
    [USER_DATA_TYPE.COLOR_BANNER, USER_DATA_TYPE.IMAGE_BANNER].includes(
      item.type
    )
  );

  if (banners.length > 1) {
    logger.error(
      'More than one banner present, please check Algolia rules',
      banners
    );
    throw new Error('More than one banner present, please check Algolia rules');
  }

  if (banners.length === 1) {
    const banner = banners[0];

    switch (banner.type) {
      case USER_DATA_TYPE.COLOR_BANNER:
        return <Banner title={banner.data.title} color={banner.data.color} />;

      case USER_DATA_TYPE.IMAGE_BANNER:
        return <ImageBanner prismicUid={banner.prismic_uid} />;
    }
  }

  return null;
};
